import React from "react";
import AddDonation from "../Donation/AddDonation";
import BackButton from "../../Components/BackButton";
import useTranslation from "../../utils/i18n/useTranslation";

const CreateExpenses = () => {
  const { t } = useTranslation();
  return (
    <>
      <BackButton title={t("addExpenseTitle")} />
      <AddDonation collection={"expense"} />
    </>
  );
};

export default CreateExpenses;
